import styled from "styled-components";
import { colorPalette, typeScale } from "../../../../utils/theme";

export const FooterContainer = styled.footer`
  background-color: ${colorPalette.blue50};
  color: ${colorPalette.white};
  padding: 28px 0;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const FooterText = styled.p`
  margin-top: 24px;
  margin-bottom: 0;
  color: ${colorPalette.textDark};
  ${typeScale.bodyXS};

  @media (max-width: 768px) {
    margin-top: 8px;
  }
`;

export const FooterHeadline = styled.h4`
  margin-bottom: 8px;
  color: ${colorPalette.textDark};
  ${typeScale.bodyXS};
`;

export const FooterButton = styled.p`
  margin-bottom: 4px;
  display: block;
  cursor: pointer;
  color: ${colorPalette.textMain};
  ${typeScale.bodySM};

  &:hover {
    transition: all 0.1s ease-in-out;
    scale: 0.97;
  }

  @media (max-width: 768px) {
    margin-bottom: 8px;
  }
`;

export const FooterLink = styled.p`
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  text-align: left;
  text-decoration: none;
  display: block;
  cursor: pointer;
  color: ${colorPalette.textDark};
  ${typeScale.bodySM};

  &:hover {
    transition: all 0.1s ease-in-out;
    scale: 0.97;
  }

  @media (max-width: 768px) {
    margin-bottom: 8px;
    ${typeScale.bodyXS};
  }
`;

export const FooterLanguageSelector = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-top: 1px solid ${colorPalette.blue200};
  border-bottom: 1px solid ${colorPalette.blue200};
  margin-top: 24px;
`;

export const LanguageSwitcher = styled.div`
  position: relative;
  display: flex;
  gap: 4px;
  cursor: pointer;
  color: ${colorPalette.textMain};
  ${typeScale.bodySM};

  span {
    display: flex;
    align-items: center;
  }

  @media (max-width: 768px) {
    ${typeScale.bodyXS};
  }
`;

export const LanguageDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background-color: ${colorPalette.blue900};
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  min-width: 120px;
  margin-top: 4px;
  border: 1px solid ${colorPalette.blue700};
`;

export const LanguageOption = styled.div<{ active: boolean }>`
  padding: 8px 16px;
  ${typeScale.bodySM};
  cursor: pointer;
  color: ${colorPalette.white};
  background-color: transparent;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${colorPalette.blue800};
    color: ${colorPalette.blue300};
    transform: translateX(2px);
  }

  @media (max-width: 768px) {
    ${typeScale.bodyXS};
  }
`;

export const FooterBottom = styled.div`
  display: flex;
  align-items: center;
  gap: 36px;
  padding-top: 16px;

  @media (max-width: 768px) {
    align-items: start;
    flex-direction: column;
    gap: 8px;
  }
`;

export const Copyright = styled.span`
  margin: 0;
  color: ${colorPalette.textDark};
  ${typeScale.bodyXS};
`;
